import * as React from 'react';
import { TextField, withStyles, FormControl } from '@material-ui/core';

const styles = (theme: any) => ({
  multilineColor: {
    color: "white"
  }
});

class Input extends React.Component<any> {
  constructor(props: any) {
    super(props);
    this.state = {
      inputVal: ""
    };
    this.changeHandler = this.changeHandler.bind(this);
  }

  public changeHandler(e: any) {
    this.props.parentFunction(e.target.value);
  }

  public render() {
    // const { classes } = this.props;
    return (
      <div className="formControl">
        <FormControl className="formControl" fullWidth={this.props.fullWidth}>
          <TextField
            id={this.props.input}
            label={this.props.placeholder}
            type={this.props.inputType}
            margin="normal"
            //   InputProps={{
            //     classes: {
            //         input: classes.multilineColor,
            //         backgroundColor: classes.multilineColor
            //     }
            // }}
            onChange={this.changeHandler}
          />
        </FormControl>
      </div>
    );
  }
}
export default withStyles(styles)(Input);


// WEBPACK FOOTER //
// ./src/components/input/Input.tsx